module.exports = __webpack_public_path__ + "static/media/logo-text.a6c0ecf0.svg";